import { useParams } from "react-router-dom";
import { courseRegistry } from "../../courses/courseRegistry.js";
import DashboardContent from  "../Content/DashboardContent/DashboardContent.jsx";
import Home from "../Home/Home.jsx";
import { getCourseAccessLevel } from "../../utils/getCourseAcessLevel.js";

export default function CourseContent(props) {
  const { courseSlug} = useParams();
  const courseConfig = courseRegistry[courseSlug];

  if (!courseConfig) {     return <Home/>   }

  const ContentComponent = courseConfig.contentComponent;

  const courseAccessLevel = getCourseAccessLevel(props.user, courseSlug);

  return ( 
    <>
{/*     <DashboardContent
      levelContentData={courseConfig.levelContentData}
    /> */}
      <ContentComponent {...props} courseSlug={courseSlug} courseConfing={courseConfig}  
        levelContentData={courseConfig.levelContentData} courseAccessLevel={courseAccessLevel}
      />
    </>
  )
}